import {
    EventCalendarMedium,
    EventCalendarSmall,
} from './templates/EventCalendarTemplate';
import {
    InteractiveArticleLarge,
    InteractiveArticleMedium,
} from './templates/InteractiveArticleTemplate';
import { LinkLarge, LinkMedium } from './templates/LinkTemplate';
import {
    MultiChoiceLarge,
    MultiChoiceMedium,
    ThisOrThatLarge,
    ThisOrThatMedium,
    VoteSliderLarge,
    VoteSliderMedium,
} from './templates/PollTemplate';
import { ShopLinkLarge, ShopLinkMedium } from './templates/ShopLinkTemplate';
import {
    StaticArticleLarge,
    StaticArticleMedium,
} from './templates/StaticArticleTemplate';
import {
    StorefrontLinkLarge,
    StorefrontLinkMedium,
} from './templates/StorefrontLinkTemplate';
import { TemplateDefinition } from './templates/TemplateUtils';
import { TilePuzzleLarge } from './templates/TilePuzzleTemplate';
import { VideoLarge, VideoMedium } from './templates/VideoTemplate';
import { TemplateId } from '@lifeserver/shared';

export const POST_TEMPLATES: Record<TemplateId, TemplateDefinition> = {
    'article-interactive-large': InteractiveArticleLarge,
    'article-interactive-medium': InteractiveArticleMedium,
    'article-static-large': StaticArticleLarge,
    'article-static-medium': StaticArticleMedium,
    'link-large': LinkLarge,
    'link-medium': LinkMedium,
    'link-shop-large': ShopLinkLarge,
    'link-shop-medium': ShopLinkMedium,
    'link-storefront-large': StorefrontLinkLarge,
    'link-storefront-medium': StorefrontLinkMedium,
    'video-large': VideoLarge,
    'video-medium': VideoMedium,
    'poll-thisorthat-medium': ThisOrThatMedium,
    'poll-thisorthat-large': ThisOrThatLarge,
    'poll-voteslider-medium': VoteSliderMedium,
    'poll-voteslider-large': VoteSliderLarge,
    'poll-multichoice-medium': MultiChoiceMedium,
    'poll-multichoice-large': MultiChoiceLarge,
    'tile-puzzle-large': TilePuzzleLarge,
    'event-calendar-small': EventCalendarSmall,
    'event-calendar-medium': EventCalendarMedium,
};

export const TEMPLATE_DISPLAY_NAMES: Record<TemplateId, string> = {
    'article-interactive-medium': 'Interactive Article - Medium',
    'article-interactive-large': 'Interactive Article - Large',
    'article-static-medium': 'Article - Medium',
    'article-static-large': 'Article - Large',
    'link-shop-medium': 'Shop Link - Medium',
    'link-shop-large': 'Shop Link - Large',
    'link-storefront-medium': 'App Store Link - Medium',
    'link-storefront-large': 'App Store Link - Large',
    'link-medium': 'Link - Medium',
    'link-large': 'Link - Large',
    'video-medium': 'Video - Medium',
    'video-large': 'Video - Large',
    'poll-thisorthat-medium': 'This or That Poll - Medium',
    'poll-thisorthat-large': 'This or That Poll - Large',
    'poll-voteslider-medium': 'Vote Slider Poll - Medium',
    'poll-voteslider-large': 'Vote Slider Poll - Large',
    'poll-multichoice-medium': 'Multiple Choice Poll - Medium',
    'poll-multichoice-large': 'Multiple Choice Poll - Large',
    'tile-puzzle-large': 'Puzzle - Large',
    'event-calendar-small': 'Event Calendar Entry - Small',
    'event-calendar-medium': 'Event Calendar Entry - Medium',
};
